import React from 'react';

import BeatRank from '../../components/BeatRank';
import ShakeDishCard from './ShakeDishCard';


function ShakeBetingGround() {

    return ( 
        <div className="bigsmallBet">
            <BeatRank />
            <ShakeDishCard />
        </div>
     );
}

export default ShakeBetingGround;